export function buildReplayPayload(data, metadata, rawSegmentBytesCount) {
  const formData = new FormData();
  formData.append('segment', new Blob([data], {
    type: 'application/octet-stream'
  }), `${metadata.session.id}-${metadata.start}`);
  const metadataAndSegmentSizes = {
    raw_segment_size: rawSegmentBytesCount,
    compressed_segment_size: data.byteLength,
    ...metadata
  };
  const serializedMetadataAndSegmentSizes = JSON.stringify(metadataAndSegmentSizes);
  formData.append('event', new Blob([serializedMetadataAndSegmentSizes], {
    type: 'application/json'
  }));
  return {
    data: formData,
    bytesCount: data.byteLength
  };
}
